import React, { Component } from 'react';

class Titulo extends Component {
    constructor(props) {
        super(props);
    }
    
    render () {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Parámetros</h1>
                        </div>
                    </div>                  
                </div>
            </div>
        );
    }
};

export default Titulo